// @flow

import * as React from 'react';

type jQuerySelection = {
  offset: () => { top: number },
  height: () => number,
  outerHeight: () => number,
  bind: (event: string, callback: ?Function) => mixed,
  unbind: (event: string, callback: ?Function) => mixed
};

declare var jQuery: {
  (query: string | ?HTMLElement): jQuerySelection
};

declare var _: {
  throttle: (callback: Function, interval: number) => () => mixed
};

type Props = {
  following: boolean,
  children: React.Node,
  el: string,
  onManualScroll: (evt: MouseEvent) => mixed
};

export default class ScrollFollower extends React.PureComponent<Props> {
  _heightMonitorInterval: IntervalID;
  _ignoreScrollEvent: ?boolean;
  _scrollThrottler: ?(evt: MouseEvent) => mixed;
  _previousHeight: ?number;

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (!this.props.following && nextProps.following) { // Switching to following
      this.enableFollowing();
    } else if (this.props.following && !nextProps.following) { // Turning off following
      this.disableFollowing();
    }
  }

  componentWillUnmount() {
    if (this.props.following) {
      this.disableFollowing();
    }
  }

  render() {
    return (
      <div className="ScrollFollowerComponent">
        {this.props.children}
      </div>
    );
  }

  scrollToBottom() {
    const $output = jQuery(this.getElement());
    const $window = jQuery(window);

    // The bottom of the window should be aligned to the bottom of the output
    const verticalPosition = ($output.offset().top + $output.outerHeight()) - $window.height();

    // Scroll to the position on the page, but set a flag so we know in the
    // onWindowScroll function we know the difference between and auto scroll,
    // and a manual scroll.
    this._ignoreScrollEvent = true;

    return window.scrollTo(0, verticalPosition);
  }

  getElement() {
    return document.getElementById(this.props.el);
  }

  enableFollowing() {
    // Monitor scrolling, but ensure it's throttled so we don't slow everything
    // down.
    this._scrollThrottler = _.throttle(this.handleWindowScroll, 500);
    jQuery(window).bind('scroll', this._scrollThrottler);

    // Monitor the height of the document
    this._heightMonitorInterval = setInterval(this.handleHeightMonitorTick, 200);

    // Also jump to the bottom of the log
    this.scrollToBottom();
  }

  disableFollowing() {
    jQuery(window).unbind('scroll', this._scrollThrottler);
    delete this._scrollThrottler;

    clearInterval(this._heightMonitorInterval);
    delete this._heightMonitorInterval;
  }

  handleWindowScroll = (evt: MouseEvent) => {
    if (this._ignoreScrollEvent) {
      delete this._ignoreScrollEvent;
    } else {
      this.props.onManualScroll(evt);
    }
  }

  handleHeightMonitorTick = () => {
    if (!document.body) {
      return;
    }

    const newHeight = document.body.clientHeight;

    // If the clientHeight changes, re-scroll to the element.
    if (this._previousHeight && (this._previousHeight !== newHeight)) {
      this.scrollToBottom();
    }

    this._previousHeight = newHeight;
  }
}
